module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fb-page fb-page-index",
    attrs: {
      "data-href": "https://www.facebook.com/WeddingSongsTWN/?fref=ts&pnref=story",
      "data-tabs": "timeline",
      "data-width": "290",
      "data-height": "200",
      "data-small-header": "true",
      "data-adapt-container-width": "true",
      "data-hide-cover": "false",
      "data-show-facepile": "true"
    }
  }, [_c('blockquote', {
    staticClass: "fb-xfbml-parse-ignore",
    attrs: {
      "cite": "https://www.facebook.com/WeddingSongsTWN/?fref=ts&pnref=story"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/WeddingSongsTWN/?fref=ts&pnref=story",
      "target": "_blink"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-703ddbc5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fanspage.vue
// module id = 165
// module chunks = 1